import React from 'react';
import ContactTypes from '../../../components/marketing/pageSections/contact/ContactTypes';

function Home(props) {
    return (
        <>
            <ContactTypes />
        </>
    );
}

export default Home;